// Footer.js
import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <p>&copy; {new Date().getFullYear()} Charity Reporting</p>
    </footer>
  );
};

export default Footer;
